export enum EBusinessIdentify {
  NAME = 'name',
  EMAIL = 'email',
  FIRST_NAME = 'First Name',
  LAST_NAME = 'Last Name',
  BUSINESS_ID = 'Business ID',
  BUSINESS_TYPE = 'Business Type',
  BUSINESS_CITY_STATE = 'Business City/State',
  COUNTRY = 'Business Country',
  BUSINESS_CATEGORY = 'Business Category',
  PROVIDER = 'Provider',
  OWNER_ID = 'Owner ID',
  TRACKED_ON = 'Tracked on',
  EMBEDDED = 'Embedded',
  SOURCE_CONTEXT = 'Source context',
  AVATAR = 'Avatar',
  APP_SOURCE = 'App Source'
}

export enum EDevice {
  TYPE = 'Device Type',
  MODEL = 'Device Model',
  PLATFORM = 'Platform',
  PLATFORM_VERSION = 'Platform Version',
  RESOLUTION = 'Resolution',
  RESOLUTION_VIEWPORT = 'Resolution - Viewport'
}

export enum EUtmParamsEvent {
  UTM_CAMPAIGN = 'utm_campaign',
  UTM_MEDIUM = 'utm_medium',
  UTM_SOURCE = 'utm_source',
  UTM_CONTENT = 'utm_content',
  UTM_TERM = 'utm_term'
}

export const UTM_DATA_STORAGE = '@twism:utm-data-storage';
